import styled from "styled-components";

export const Container = styled.section`
  background: ${props => props.theme.backgroundDark};
  height: 356px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 16px;

  .header {
    margin-bottom: 0px;
  }

  .title {
    margin-top: -20px;
    margin-bottom: 64px;
    margin-left: 7.2vw;
  }

  .content {
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    .logo {
      &:first-child {
        width: 130px;
      }

      &:nth-child(2) {
        width: 50px;
      }
      &:nth-child(3) {
        width: 110px;
      }
      &:nth-child(4) {
        width: 288px;
      }
      &:nth-child(5) {
        width: 144px;
      }
      &:nth-child(6) {
        width: 94px;
      }
    }
  }

  @media (max-width: 1000px) {
    height: fit-content;
    justify-content: center;

    .title {
      margin-top: 52px;
      margin-bottom: 32px;
      margin-left: 5vw;
    }

    .content {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-items: start;
      align-items: start;
      margin-left: 5vw;
      padding-bottom: 52px;

      .logo {
        margin-bottom: 20px;
        &:nth-child(4) {
          width: 114px;
          margin-left: -3vw;
        }

        &:nth-child(5) {
          grid-column: 1/-1;
          width: 230px;
          justify-self: start;
          margin-left: 40px;
        }

        &:nth-child(7) {
          align-self: center;
        }
      }
    }
  }
`;
